import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import FacebookIcon from '@mui/icons-material/Facebook';

import { FACEBOOK_APP_ID } from '../../config';
import { FB_VERSION, startFacebookLogin } from './facebookAccount';

class FacebookLogin extends Component {
  constructor(props) {
    super(props);
    this.state = { error: '' };
  }

  initFacebookSdk() {
    return new Promise((resolve) => {
      // wait for facebook sdk to initialize before starting the react app
      if (window.FB) {
        resolve();
        return;
      }

      window.fbAsyncInit = function () {
        window.FB.init({
          appId: FACEBOOK_APP_ID,
          cookie: true,
          xfbml: true,
          version: FB_VERSION,
        });
        resolve();
      };

      // load facebook sdk script
      (function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    });
  }

  // async apiAuthenticate(accessToken) {
  //     // authenticate with the api using a facebook access token,
  //     // on success the api returns an account object with a JWT auth token
  //     const response = await axios.post(`${baseUrl}/authenticate`, { accessToken });
  //     const account = response.data;
  //     accountSubject.next(account);
  //     startAuthenticateTimer();
  //     return account;
  // }

  login() {
    if (!window.FB) {
      this.setState({ error: 'Facebook is still loading. Please try again in a moment.' });
      return;
    }

    this.setState({ error: '' });
    startFacebookLogin(window.FB, {
      userType: this.props.userType,
      onSuccess: (authResponse, account) => this.props.onSuccess(authResponse, account),
      onError: (error) => {
        // 'cancelled' just means they closed the dialog, so say nothing.
        if (error.message === 'cancelled') return;
        if (this.props.onError) this.props.onError(error);
        this.setState({ error: error.message });
      },
    });
  }

  async logout() {
    // stopAuthenticateTimer();
    // accountSubject.next(null);
    // history.push('/login');
  }

  componentDidMount() {
    this.initFacebookSdk().then(() => {});
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className="inf-social-btn inf-social-btn--fb"
          onClick={() => {
            this.login();
          }}
          disabled={this.props.is_linked}
          style={{
            background: '#1877f2',
            color: '#fff',
            border: 0,
            borderRadius: 12,
            padding: '13px 18px',
            fontSize: 15,
            fontWeight: 700,
            cursor: this.props.is_linked ? 'default' : 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            width: '100%',
          }}
        >
          <FacebookIcon style={{ fontSize: 20 }} />
          {this.props.label}
        </button>
        {this.state.error ? (
          <div style={{ color: '#c62828', fontSize: 12, maxWidth: 280, marginTop: 6 }}>
            {this.state.error}
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRouter(FacebookLogin);
